import React from "react";
import WorkflowStageInfoBanner from "../../../stageWorkflow/components/WorkflowStageInfoBanner";

const PostIrAssessmentSubmittedStage: React.FC = () => {
  return (
    <WorkflowStageInfoBanner
      title="Pending with FRMD to Review Recommendations from IO Appointing Authority"
    />
  );
};

export default PostIrAssessmentSubmittedStage;